class Nav {
	init($nav) {
		this.state = {
			openFoldoutId: null,
			searchIsOpen: false,
			languageIsOpen: false,
			isScrolled: false,
			scrollTimer: null,
		}

		this.activeClass = "c-nav--scrolled"

    this.$nav = $nav
    this.$navPrimary = document.querySelector(".js--nav__primary")
    this.$foldoutTriggers = $nav.querySelectorAll(".js--nav__toggle-foldout")

		this.$foldouts = $nav.querySelectorAll(".js--nav__foldout")
		this.$secondaryBar = $nav.querySelector(".js--nav__bottom-bar")
		this.$toggleLanguage = $nav.querySelectorAll(".js--nav__toggle-language")
		this.$languageFoldout = $nav.querySelector(".js--nav__language-foldout")
		this.$toggleSearch = $nav.querySelector(".js--nav__toggle-search")
		this.$searchFoldout = $nav.querySelector(".js--nav__search-foldout")
    this.$searchInput = $nav.querySelector(".js--nav__search-input")
    this.$searchSubmit = $nav.querySelector(".js--nav__search-submit")
    this.$listNavlinks = $nav.querySelectorAll(".c-nav-secondary__link")
    this.$quickLinks = $nav.querySelectorAll(".js--nav__search-quicklink")
    this.$searchRoot = $nav.dataset.searchUrl

		this.handleToggleFoldout()
		this.handleToggleLanguage()
		this.handleToggleSearch()

		window.addEventListener(
			"scroll",
			() => {
				this.handleScroll()
			},
			false
    )

    if (this.$searchInput) {
      this.$searchInput.addEventListener("keyup", (e) => {
				this.$searchInput.classList.remove("error")
				if (e.key === "Enter" || e.keyCode === 13) {
					this.submitSearch()
				}
			})

			this.$searchSubmit.addEventListener("click", () => {
				this.submitSearch()
      })

      this.$quickLinks.forEach(($link) => {
        $link.addEventListener("click", (e)=> {
          e.preventDefault()
          window.location.href = `${this.$searchRoot}#?query=${$link.dataset.searchterm}`
          if (document.querySelector("[data-issearchpage]")) {
						window.location.reload()
					}
        })
      })
    }


		document.addEventListener(
			"click",
			(e) => {
				if (this.state.openFoldoutId) {
					const $isTriggerClicked = e.target.classList.contains(
						"c-nav-secondary__link"
					)
					const $isFoldoutCliked = document
						.getElementById(this.state.openFoldoutId)
						.contains(e.target)
					if (!$isFoldoutCliked && !$isTriggerClicked) {
						this.closeFoldout(this.state.openFoldoutId)
					}
				}
				if (this.$searchFoldout) {
					const isSearchTriggerClicked = this.$toggleSearch.contains(e.target)
          const isSearchFoldoutClicked = this.$searchFoldout.contains(e.target)
					if (!isSearchFoldoutClicked && !isSearchTriggerClicked) {
						this.closeSearch()
					}
				}
			},
			false
		)
	}

	openFoldout(id) {
		this.closeSearch()
		this.$secondaryBar.classList.add("has-open-item")

		for (let i = 0; i < this.$foldoutTriggers.length; i += 1) {
			const $trigger = this.$foldoutTriggers[i]
			if ($trigger.dataset.foldoutTarget === id) {
				$trigger.classList.add("is-open")
			}
		}

		for (let i = 0; i < this.$foldouts.length; i += 1) {
			const $foldout = this.$foldouts[i]
			if ($foldout.id === id) {
				$foldout.classList.add("is-open")
				this.state.openFoldoutId = id
			}
		}
	}

	handleScroll() {
		if (document.querySelector("html").classList.contains("p-homepage")) {
			return
		}

		if (this.state.scrollTimer) {
			clearTimeout(this.state.scrollTimer)
		}

		this.state.scrollTimer = setTimeout(() => {
			let scrollY = window.scrollY || window.pageYOffset

			if (scrollY > 0 && !this.state.isScrolled) {
				// this.closeSearch()

				this.state.isScrolled = true
				this.$nav.classList.add(this.activeClass)
			} else if (scrollY <= 0) {
				this.state.isScrolled = false
				this.$nav.classList.remove(this.activeClass)
			}
		}, 15)
	}

	closeFoldout(id) {
		this.$secondaryBar.classList.remove("has-open-item")

		for (let i = 0; i < this.$foldoutTriggers.length; i += 1) {
			const $trigger = this.$foldoutTriggers[i]
			if ($trigger.dataset.foldoutTarget === id) {
				$trigger.classList.remove("is-open")
			}
		}

		for (let i = 0; i < this.$foldouts.length; i += 1) {
			const $foldout = this.$foldouts[i]
			if ($foldout.id === id) {
				$foldout.classList.remove("is-open")
				this.state.openFoldoutId = null
			}
		}
	}

	handleToggleFoldout() {
		for (let i = 0; i < this.$foldoutTriggers.length; i += 1) {
			const $trigger = this.$foldoutTriggers[i]

			if (!$trigger.classList.contains("has-foldout")) {
				return
			}

			$trigger.addEventListener("click", (e) => {
				e.preventDefault()
				if (e.target.dataset.foldoutTarget === this.state.openFoldoutId) {
					this.closeFoldout(e.target.dataset.foldoutTarget)
				} else {
					this.closeFoldout(this.state.openFoldoutId)
					this.openFoldout(e.target.dataset.foldoutTarget)
				}
			})
		}
	}

	handleToggleLanguage() {
		if (this.$languageFoldout !== null) {
			this.$languageFoldout.addEventListener("mouseleave", (e) => {
				if (this.state.languageIsOpen) {
					this.closeLanguage()
				}
			})
		}

		;[...this.$toggleLanguage].forEach(($el) => {
			$el.addEventListener("click", () => {
				if (this.state.languageIsOpen) {
					this.closeLanguage()
				} else {
					this.openLanguage()
				}
			})
		})
	}

	openLanguage() {
		if (this.$languageFoldout !== null) {
			this.state.languageIsOpen = true
			this.$navPrimary.classList.add("lang-is-open")
			this.$languageFoldout.classList.add("is-open")
			document.activeElement.blur()
		}
	}

	closeLanguage() {
		if (this.$languageFoldout !== null) {
      this.state.languageIsOpen = false
      this.$navPrimary.classList.remove("lang-is-open")
			this.$languageFoldout.classList.remove("is-open")
			document.activeElement.blur()
		}
	}

	handleToggleSearch() {
		if (this.$toggleSearch !== null) {
			this.$toggleSearch.addEventListener("click", () => {
        if (this.$foldoutTriggers.length > 0) {
          this.closeFoldout(this.state.openFoldoutId)
        }
				if (this.state.searchIsOpen) {
					this.closeSearch()
				} else {
					this.openSearch()
				}
			})
		}
	}

	openSearch() {
		if (this.$searchFoldout !== null) {
			this.state.searchIsOpen = true
			this.$searchFoldout.classList.add("is-open")
			setTimeout(() => {
				this.$searchInput.focus()
				window.addEventListener("click", this.clickOutsideSearch)
			}, 250)
		}
	}

	closeSearch() {
		if (this.$searchFoldout !== null) {
			this.state.searchIsOpen = false
			this.$searchFoldout.classList.remove("is-open")
		}
  }

  submitSearch() {
    const searchTerm = this.$searchInput.value
    if (searchTerm.length === 0) {
      this.$searchInput.classList.add('error');
    } else {
      window.location.href = `${this.$searchRoot}#?query=${searchTerm}`
      if (document.querySelector("[data-issearchpage]")) {
        window.location.reload()
			}
    }
  }
}

;[...document.querySelectorAll(".js--nav")].forEach(($el) => {
	const inst = new Nav()
	inst.init($el)
})
